import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import dynamic from 'next/dynamic';
import { AdminGuard } from '@techstyle/react-admin';
import accountsModule, { loadLoyaltyDetails, loadCustomerDetails, loadMembership, loadMembershipPeriod, loadProfile, loadPayments } from './accountsModule';
import logger from './logger';
var debug = logger.extend('accountsExtension');
var CustomerDetailsAdminPanel = dynamic(function () {
  return import(
  /* webpackChunkName: "AdminTools" */
  './CustomerDetailsAdminPanel');
});
var CustomerEmailAdminPanel = dynamic(function () {
  return import(
  /* webpackChunkName: "AdminTools" */
  './CustomerEmailAdminPanel');
});
var MembershipDetailsAdminPanel = dynamic(function () {
  return import(
  /* webpackChunkName: "AdminTools" */
  './MembershipDetailsAdminPanel');
});
export default function accountsExtension() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$defaultProfileRe = _ref.defaultProfileRequired,
      defaultProfileRequired = _ref$defaultProfileRe === void 0 ? true : _ref$defaultProfileRe,
      _ref$defaultMembershi = _ref.defaultMembershipRequired,
      defaultMembershipRequired = _ref$defaultMembershi === void 0 ? true : _ref$defaultMembershi,
      _ref$defaultMembershi2 = _ref.defaultMembershipPeriodRequired,
      defaultMembershipPeriodRequired = _ref$defaultMembershi2 === void 0 ? false : _ref$defaultMembershi2,
      _ref$defaultLoyaltyDe = _ref.defaultLoyaltyDetailsRequired,
      defaultLoyaltyDetailsRequired = _ref$defaultLoyaltyDe === void 0 ? false : _ref$defaultLoyaltyDe,
      _ref$defaultPaymentsR = _ref.defaultPaymentsRequired,
      defaultPaymentsRequired = _ref$defaultPaymentsR === void 0 ? false : _ref$defaultPaymentsR,
      globalPrefetchCustomerDetails = _ref.globalPrefetchCustomerDetails;

  return function (registry) {
    return {
      id: 'accounts',
      redux: {
        modules: [accountsModule]
      },
      server: process.browser ? undefined : {
        init: function init() {
          require('./config');
        }
      },
      app: {
        render: function render(props, children) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(AdminGuard, null, /*#__PURE__*/React.createElement(CustomerDetailsAdminPanel, null), /*#__PURE__*/React.createElement(CustomerEmailAdminPanel, null), /*#__PURE__*/React.createElement(MembershipDetailsAdminPanel, null)));
        }
      },
      page: function page(options) {
        var _options$membershipRe = options.membershipRequired,
            membershipRequired = _options$membershipRe === void 0 ? defaultMembershipRequired : _options$membershipRe,
            _options$membershipPe = options.membershipPeriodRequired,
            membershipPeriodRequired = _options$membershipPe === void 0 ? defaultMembershipPeriodRequired : _options$membershipPe,
            _options$profileRequi = options.profileRequired,
            profileRequired = _options$profileRequi === void 0 ? defaultProfileRequired : _options$profileRequi,
            _options$loyaltyDetai = options.loyaltyDetailsRequired,
            loyaltyDetailsRequired = _options$loyaltyDetai === void 0 ? defaultLoyaltyDetailsRequired : _options$loyaltyDetai,
            _options$paymentsRequ = options.paymentsRequired,
            paymentsRequired = _options$paymentsRequ === void 0 ? defaultPaymentsRequired : _options$paymentsRequ,
            prefetchCustomerDetails = options.prefetchCustomerDetails;
        var getPrefetchCustomerDetails = registry.utils.getMergedArrayOption({
          globalPrefetchCustomerDetails: globalPrefetchCustomerDetails,
          prefetchCustomerDetails: prefetchCustomerDetails
        });
        return {
          getInitialProps: function getInitialProps(ctx) {
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var _yield$getPrefetchCus, _yield$getPrefetchCus2, prefetchCustomerDetails, meta;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return getPrefetchCustomerDetails(ctx);

                    case 2:
                      _yield$getPrefetchCus = _context.sent;
                      _yield$getPrefetchCus2 = _slicedToArray(_yield$getPrefetchCus, 2);
                      prefetchCustomerDetails = _yield$getPrefetchCus2[0];
                      meta = _yield$getPrefetchCus2[1];

                      if (prefetchCustomerDetails.length) {
                        debug('Prefetching %s %s added by %s.', prefetchCustomerDetails.length, prefetchCustomerDetails.length === 1 ? 'customer detail' : 'customer details', meta.sources.join(', '));
                      }

                      _context.next = 9;
                      return Promise.all([membershipRequired ? ctx.store.dispatch(loadMembership()) : null, membershipPeriodRequired ? ctx.store.dispatch(loadMembershipPeriod()) : null, profileRequired ? ctx.store.dispatch(loadProfile()) : null, paymentsRequired ? ctx.store.dispatch(loadPayments()) : null, loyaltyDetailsRequired ? ctx.store.dispatch(loadLoyaltyDetails()) : null, prefetchCustomerDetails.length ? ctx.store.dispatch(loadCustomerDetails(prefetchCustomerDetails)) : null]);

                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))();
          }
        };
      }
    };
  };
}